import { createContext, type RefObject, useContext } from "react";
import type { VirtuosoHandle } from "react-virtuoso";
import type { CalendarItem, CalendarItemColor } from "./shared";

/** Interface */
interface ICalendarContext<T extends object = object> {
	earliestDate: string;
	virtuosoHandle: RefObject<VirtuosoHandle>;
	getItemColor?: (item: CalendarItem<T>) => CalendarItemColor;
	renderItemContent?: (item: CalendarItem<T>) => React.ReactNode;
	onItemClick?: (item: CalendarItem<T>) => void;
}

/** Context */
export const CalendarContext = createContext<ICalendarContext>({} as ICalendarContext);

/** Hooks */
export function useCalendarContext(): ICalendarContext {
	return useContext(CalendarContext);
}
